export const nextAvailableTitle = (prefix, allTitles, isDuplicate = false) => {
    // if no titles like it exist yet, simply return
    const titleSet = new Set(allTitles);
    if (!titleSet.has(prefix)) {
        return prefix;
    }
    // remove postfix counters
    //   duplicate 1: "title copy" -> "title"
    //   duplicate 2: "title copy (1)" -> "title"
    //   non-duplicate: "title 1" -> "title"
    const simplePrefix = isDuplicate
        ? prefix.replace(/( copy( \(\d+\))?)$/, '')
        : prefix.replace(/( \d+)?$/, '');
    if (!titleSet.has(simplePrefix)) {
        return simplePrefix;
    }
    if (isDuplicate) {
        // Duplicate format:
        //   Prefix copy, Prefix copy (1), Prefix copy (2), ...
        const firstCopy = `${simplePrefix} copy`;
        if (!titleSet.has(firstCopy)) {
            return firstCopy;
        }
        let nextTitleI = 1;
        while (titleSet.has(`${firstCopy} (${nextTitleI})`)) {
            nextTitleI++;
        }
        return `${firstCopy} (${nextTitleI})`;
    }
    else {
        // Non-duplicate format:
        //   Prefix 1, Prefix 2, ...
        let nextTitleI = 1;
        while (titleSet.has(`${simplePrefix} ${nextTitleI}`)) {
            nextTitleI++;
        }
        return `${simplePrefix} ${nextTitleI}`;
    }
};
//# sourceMappingURL=titles.js.map